import React from 'react';
import { Link } from 'react-router-dom';

const RightPanel = ({ conversation, role = 'WHS' }) => {
  const links = conversation?.links || {};
  const customer = conversation?.customer;
  const assigned = conversation?.assignedTo;

  return (
    <div style={{ padding:12, borderLeft:'1px solid #eee', height:'100%', overflow:'auto' }}>
      <h3 style={{ marginTop:0 }}>Details</h3>
      <section style={{ marginBottom:12 }}>
        <div style={{ color:'#6b7280', fontSize:12 }}>Customer</div>
        <div>{customer?.companyName || `${customer?.firstName || ''} ${customer?.lastName || ''}` || '-'}</div>
      </section>
      {role !== 'RTL' && (
        <section style={{ marginBottom:12 }}>
          <div style={{ color:'#6b7280', fontSize:12 }}>Assigned</div>
          <div>{assigned ? (assigned.companyName || `${assigned.firstName || ''} ${assigned.lastName || ''}`) : 'Unassigned'}</div>
        </section>
      )}
      <section style={{ marginBottom:12 }}>
        <div style={{ color:'#6b7280', fontSize:12 }}>Linked Order</div>
        {links.orderId ? (
          <div>
            <div>Order #: {links.orderNumber || '-'}</div>
            <Link to={`/orders/${links.orderId}`}>Open Order</Link>
          </div>
        ) : (
          <div>No linked order</div>
        )}
      </section>
      <section>
        <div style={{ color:'#6b7280', fontSize:12 }}>Inbox</div>
        <div>{conversation?.inbox || 'support'}</div>
      </section>
    </div>
  );
};

export default RightPanel;
